import type { LoyaltyVideoPlayerProps as UILoyaltyVideoPlayerProps } from "@jti/loyalty";

import type { loyaltyVideoPlayerInputs } from "@/components/LoyaltyVideoPlayer/LoyaltyVideoPlayer.builder";

type SharedVideoProps = BuilderComponentProps<typeof loyaltyVideoPlayerInputs>;

export function buildLoyaltyVideoUIProps(props: SharedVideoProps): UILoyaltyVideoPlayerProps | undefined {
  const { video } = props;

  if (!video) {
    return undefined;
  }

  const commonProps: Partial<UILoyaltyVideoPlayerProps> = {
    title: video.title,
    poster: video.posterImage,
    description: video.description,
    playLabel: video.playLabel,
    replayLabel: video.replayLabel,
    soundOnLabel: video.soundOnLabel,
    muteLabel: video.muteLabel,
    showFullscreenLabel: video.showFullScreenLabel,
    showDuration: video.duration,
    showFullscreen: video.showFullscreen,
    showControls: video.showControls,
    preventMainPlayButtonClick: video.preventMainPlayButtonClick,
    preload: video.preload,
    contentSize: video.contentSize,
    themeClass: video.controlColor === "light" ? "dark-theme" : "light-theme",
    percentageToWatch: props.percentageToWatch ? +props.percentageToWatch : undefined,
    disableSeek: video.disableSeek,
  };

  const videoProps: UILoyaltyVideoPlayerProps =
    video.videoType === "youtube"
      ? {
          ...commonProps,
          desktopSrc: "",
          externalLinkVideo: video?.youtubeConfiguration?.externalLinkVideo,
          hostedExternally: true,
          videoId: props.videoId,
        }
      : {
          ...commonProps,
          loop: video.hostedVideoConfiguration?.loop,
          autoPlay: video.hostedVideoConfiguration?.autoPlay,
          desktopSrc: video.hostedVideoConfiguration?.desktopSrc || "",
          tabletSrc: video.hostedVideoConfiguration?.tabletSrc,
          mobileSrc: video.hostedVideoConfiguration?.mobileSrc,
          alt: video.posterAlt,
          videoId: props.videoId,
        };

  return videoProps;
}
